// Clean (LOOKS.md): the base look and the default. It lays no ground of its own
// (it sits on the palette's), draws every icon, glyph and cup the kit has, and
// needs no fonts beyond the page's.

import { defineLook } from '../define';
import './look.css';

export default defineLook({
  id: 'clean',
  label: 'Clean',
  blurb: 'Sharp type, hairlines, one accent. The default.',
  order: 0,
  grounds: null,
  fonts: null,
});
